import * as React from 'react';
import { cn, superScriptSanitizer } from '../../../helpers';

import './section-title.style.scss';

const baseClass = 'section-title';

const heading = (
    text: string,
    icon?: React.ReactChild[] | React.ReactChild | null,
    subText?: React.ReactChild[] | React.ReactChild | null,
    className?: string,
    infoIcon?: React.ReactChild[] | React.ReactChild | null,
) => (
    <h1 className={cn('h3', className)}>
        {icon}
        {superScriptSanitizer(text)}
        {subText}
        {infoIcon}
    </h1>
);

const sectionTitle = function SectionTitle(props: SectionTitleProps) {
    const { hash, text, subText, icon, onClick, className, InfoIcon } = props;

    if (hash) {
        return (
            <a href={`#${hash}`} title="" className={cn(baseClass, className)} onClick={onClick} onFocus={onClick} data-testid={`section-title-${hash}`}>
                {heading(text, icon, subText, undefined, InfoIcon)}
            </a>
        );
    }

    return heading(text, icon, subText, className ? `${baseClass} ${className}` : baseClass, InfoIcon);
};

export default React.memo(sectionTitle);
